import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_ORIGIN } from '../../config';

/**
 * The mail-gateway invite flow. An invitee lands on the app via
 * `/?invite=<token>&email=<address>`, resolves who invited them, claims their
 * handle + password (onboarding), then signs in like anyone else.
 */
export interface InviteInfo {
  inviterHandle: string | null;
  provisionalHandle: string;
  /** A stamp book held for them, gifted along with the invite. */
  gift?: { collectionName: string } | null;
}

export const mailApi = createApi({
  reducerPath: 'mailApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_ORIGIN}/api/mail`, credentials: 'include' }),
  endpoints: (b) => ({
    inviteInfo: b.mutation<InviteInfo, { token: string; email: string }>({
      query: (body) => ({ url: '/invite/info', method: 'POST', body }),
    }),
    onboard: b.mutation<{ userId: string; relationshipId: string | null }, { token: string; email: string; password: string; handle: string }>({
      query: (body) => ({ url: '/invite/onboard', method: 'POST', body }),
    }),
    /** Member-initiated: invite someone by email to join and connect (2026-02-10). */
    inviteFriend: b.mutation<{ email: string }, { email: string; message?: string }>({
      query: (body) => ({ url: '/invite', method: 'POST', body }),
    }),
  }),
});

export const { useInviteInfoMutation, useOnboardMutation, useInviteFriendMutation } = mailApi;